import ApiModule from './index'
// import { UtilDevice } from '@iskytrip/sdk'
import BaseModel from '../../base/BaseModel'

export class GetOperationActivityDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.MARKETACTIVITIES
		this.url = '/operationActivity/getOperationActivityDetail'
		this.desc = '获取运营活动明细'
	}

	dataformat(data) {
		super.dataformat(data)

		const { resultData = {} } = data
		return {
			isShare: !!resultData.isShared || !!0,
			shareInfo: {
				url: (resultData.shareInfo || {}).sharePageUrl,
				title: (resultData.shareInfo || {}).sharedTitle,
				img: (resultData.shareInfo || {}).sharePageImage,
				cont: (resultData.shareInfo || {}).sharedContent,
				shareWebPage: (resultData.shareInfo || {}).shareWebPage,
				clientKey: (resultData.shareInfo || {}).sharePageClientKey,
			},
			dataSource: {
				title: resultData.title || '',
				description: resultData.description || '',
				banner: resultData.operationBannerUrl || '',
				modelList: (resultData.activityModelList || []).map((activityModel) => ({
					id: activityModel.activityModelId,
					actionDesc: activityModel.actionDesc || '',
					actionMark: activityModel.actionMark || '',
					title: activityModel.activityModelName || '',
					airportName: activityModel.airportName || '',
					airportCode: activityModel.airportCode || '',
					list: (activityModel.productList || []).slice(0, 4).map((product) => ({
						nm: product.title || '',
						id: product.productId,
						amt: product.minPrice || 0,
						img: product.bgImage || '',
						addr: `${product.terminalName || ''} ${product.termArea ||
							''}${product.departArea || ''}${product.securityArea || ''}`,
					})),
				})),
			},
		}
	}
}
